const SELISE_CLUB_EPOCH = Math.floor(new Date("2026-04-20").getTime() / 1000);
const ENGAGEMENT_WEIGHT = 3;
const COMMENT_WEIGHT = 4;

export const hot = (reacts: number, comments: number, date: Date) => {
  const unixSeconds = Math.floor(date.getTime() / 1000);
  const engagement = reacts * 2 + comments * COMMENT_WEIGHT;
  const order = ENGAGEMENT_WEIGHT * Math.log10(Math.max(engagement, 1));
  const seconds = unixSeconds - SELISE_CLUB_EPOCH;
  return Math.round((order + seconds / 90000) * 1000) / 1000;
};
